import { Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Input } from '../../../ui/Input';
import { GoldCorners } from '../WizardDividers';

interface DatesStepProps {
  startDate: string;
  endDate: string;
  onStartChange: (v: string) => void;
  onEndChange: (v: string) => void;
  onSkip: () => void;
  isEnthusiast: boolean;
  firstDest: string;
  isUkiyo: boolean;
}

export function DatesStep({ startDate, endDate, onStartChange, onEndChange, onSkip, isEnthusiast, firstDest, isUkiyo }: DatesStepProps) {
  const { t } = useTranslation('pages');
  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <Input
          label={t('tripPlanner.startDate')}
          type="date"
          value={startDate}
          onChange={e => onStartChange(e.target.value)}
          leftIcon={<Calendar size={16} />}
        />
        <Input
          label={t('tripPlanner.endDate')}
          type="date"
          value={endDate}
          onChange={e => onEndChange(e.target.value)}
          leftIcon={<Calendar size={16} />}
        />
      </div>

      <button
        type="button"
        onClick={onSkip}
        className="text-sm text-secondary-600 dark:text-secondary-400 hover:underline"
      >
        {t('onboarding.skipDates')}
      </button>

      {isEnthusiast && firstDest && (
        isUkiyo ? (
          <div style={{
            border: '1px solid rgba(27,79,138,0.25)', background: '#EDE4CC',
            padding: '9px 12px', position: 'relative', marginTop: 12,
          }}>
            <GoldCorners size={8} />
            <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 12, color: '#1B5C8A', lineHeight: 1.5, margin: 0, paddingLeft: 4 }}>
              {t('onboarding.tripWillBeCreated', { dest: firstDest })}
            </p>
          </div>
        ) : (
          <div className="mt-4 p-3 rounded-lg flex items-start gap-2 text-sm bg-primary-50 dark:bg-primary-900/20 border border-primary-200 dark:border-primary-800 text-primary-800 dark:text-primary-200">
            <Calendar size={14} className="mt-0.5 shrink-0" />
            <p>{t('onboarding.tripWillBeCreated', { dest: firstDest })}</p>
          </div>
        )
      )}
    </div>
  );
}
